import {
    OPS_HEALTH_LOADING,
    SUCCESS_GET_OPS_HEALTH,
    FAILED_GET_OPS_HEALTH,
} from '../constants/opsHealthConstants';

const initialState = {
    summary: {
        healthy: 0,
        warning: 0,
        failed: 0,
        last_checked: null,
    },
    checks: [],
    loading: false,
    errorMessage: '',
};

export const OpsHealthReducer = (state = initialState, action) => {
    switch (action.type) {
        case OPS_HEALTH_LOADING:
            return {
                ...state,
                loading: true,
            };

        case SUCCESS_GET_OPS_HEALTH:
            return {
                ...state,
                summary: action.payload.summary || initialState.summary,
                checks: action.payload.checks || [],
                loading: false,
                errorMessage: '',
            };

        // Keep the last good checks on screen so a failed refresh does not blank the board.
        case FAILED_GET_OPS_HEALTH:
            return {
                ...state,
                loading: false,
                errorMessage: action.errorMessage,
            };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// src/state/reducers/opsHealthReducer.js